import { Component, OnInit } from '@angular/core';
import {FiltersService} from '../../../../services/filters.service';
import {AssetsService} from '../../../../services/assets.service';

@Component({
  selector: 'app-no-filtered-offers',
  templateUrl: './no-filtered-offers.component.html',
  styleUrls: ['./no-filtered-offers.component.scss']
})
export class NoFilteredOffersComponent implements OnInit {

  constructor(private filtersService: FiltersService,
              public assetsService: AssetsService) { }

  ngOnInit() {
  }

  resetFilters(): void {
    this.filtersService.resetFilters();
  }

}
